export const SLA_OVERRIDE_OTHER_CODE = 'other';

// Stable codes shared across reports (process_lag, extraordinary_event, chair_only, other)
// so a later top-five rollup can sum the same reason across SLA sections.
const SLA_OVERRIDE_REASONS = {
    process_lag: 'Process Lag',
    passenger_not_at_desk: 'Passenger Not at Desk',
    check_in_not_open: 'Check-In Not Open',
    meet_at_gate: 'Meet at Gate',
    chair_only: 'Chair Only',
    extraordinary_event: 'Extraordinary Event',
    other: 'Other',
    late_inbound: 'Late Inbound',
    ocs_on_time_before_boarding: 'OCS On Time Before Boarding Started',
    ocs_at_location_within_5_min: 'OCS at Location Within 5 Minutes of Inbound Arrival',
    passenger_did_not_require_boarding: 'Passenger Did Not Require Boarding Assistance',
    passenger_boarded_themselves: 'Passenger Boarded Themselves',
    no_show_disregarded: 'No Show – Disregarded',
    inbound_still_disembarking: 'Inbound Still Disembarking (All disembarked KPI)',
    passenger_convenience: 'Passenger Convenience (All disembarked KPI)',
    awaiting_mobility_equipment: 'Awaiting Mobility Equipment (All disembarked KPI)',
    no_further_assistance: 'No Further Assistance Required',
    passenger_could_not_be_located: 'Passenger Could Not Be Located',
};

const optionsFor = (codes) => codes.map((code) => ({ code, label: SLA_OVERRIDE_REASONS[code] }));

export const SLA_OVERRIDE_REASON_OPTIONS = {
    terminalReception: optionsFor([
        'process_lag',
        'passenger_not_at_desk',
        'check_in_not_open',
        'meet_at_gate',
        'chair_only',
        'extraordinary_event',
        'other',
    ]),
    boardings: optionsFor([
        'process_lag',
        'late_inbound',
        'ocs_on_time_before_boarding',
        'ocs_at_location_within_5_min',
        'passenger_did_not_require_boarding',
        'passenger_boarded_themselves',
        'extraordinary_event',
        'other',
    ]),
    inbounds: optionsFor([
        'process_lag',
        'no_show_disregarded',
        'inbound_still_disembarking',
        'passenger_convenience',
        'awaiting_mobility_equipment',
        'extraordinary_event',
        'other',
    ]),
    terminalHoldingPoints: optionsFor([
        'chair_only',
        'no_further_assistance',
        'extraordinary_event',
        'other',
    ]),
    helpPoints: optionsFor([
        'passenger_could_not_be_located',
        'extraordinary_event',
        'other',
    ]),
};

/**
 * @returns {{ reasonCode: string, reasonDetail: string|null, passReason: string }|null}
 */
export function resolveSlaOverrideReason(code, otherText) {
    const label = SLA_OVERRIDE_REASONS[code];
    if (!label) return null;

    if (code === SLA_OVERRIDE_OTHER_CODE) {
        const detail = (otherText || '').trim();
        if (!detail) return null;
        return {
            reasonCode: code,
            reasonDetail: detail,
            passReason: `Other – ${detail}`,
        };
    }

    return {
        reasonCode: code,
        reasonDetail: null,
        passReason: label,
    };
}
